import axios from './../../function/axiosInstance'
import extract from './../../function/extract'

export interface GetProjectsResponseData {
  records: Project[]
  total_records: number
}

export type GetProjectsReturnType = Promise<
  ApiResponseV2<GetProjectsResponseData>
>

interface GetProjectsParameters {
  query_params?: Partial<ProjectQueryParams>
  page?: number
  page_size?: number
  paginationEnabled?: boolean
}

export const getProjects = async ({
  query_params: queryParams = {},
  page: currentPage = 0,
  page_size: pageSize = 10,
  paginationEnabled = true
}: GetProjectsParameters): GetProjectsReturnType => {
  try {
    const params = {
      ...(paginationEnabled && {
        current_page: currentPage,
        page_size: pageSize,
        pagination_enabled: true
      }),
      ...queryParams
    }

    const response = await axios.get<GetProjectsResponseData>('/projects', {
      params
    })

    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
